import React, { useState } from 'react';
import './Login.css';
import api from './api';

export default function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      // 使用api.js中的login方法进行登录
      const data = await api.login(username, password);
      // 保存令牌到localStorage
      localStorage.setItem('accessToken', data.access);
      localStorage.setItem('refreshToken', data.refresh);

      // 使用api.js中的getUserInfo方法获取用户信息
      const userData = await api.getUserInfo();
      // 调用回调函数通知父组件登录成功
      onLogin({ id: userData.id, username: userData.username, token: data.access });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page-wrapper">
      <div className="login-container">
        <h2>登录</h2>
        {error && <div className="error-message">{error}</div>}
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="username">用户名</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">密码</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit" disabled={loading} className="login-button">
            {loading ? '登录中...' : '登录'}
          </button>
        </form>
      </div>
      <footer className="icp-footer">
        <a href="http://beian.miit.gov.cn/" target="_blank" rel="noreferrer">粤ICP备2025509815号-1</a>
      </footer>
    </div>
  );
}
